// only add flags to this enum if you want your experiment to be activated for all users in your audience
export enum OPTIMIZELY_FLAGS_ENUM {
  AGE_MFE_ACTIVATE_PLACES_API = 'age_mfe_activate_places_api',
  SEARCH_SUGGESTIONS_REST_API = 'search___search_suggestions_rest_api',
  APPSFLYER_BANNER = 'guest_experience_appsflyer_banner',
  DRIVE_TIME_SEARCH = 'guest_discovery___drivetime',
}

export const AGE_ACQUISITION_LINKS_CTA_IN_PODS_MODULE =
  'age_acquisition_links_cta_in_pods_module'
export const AGE_ACQUISITION_CLICKED_ON_DESTINATION_PAGE_MAP =
  'age_acquisition_clicked_on_destination_page_map'
export const AGE_ACQUISITION_CLICKED_ON_THEME_PAGE_MAP =
  'age_acquisition_clicked_on_theme_page_map'
export const OPTIMIZELY_EVENT_AGE_ACQUISITION_CLICKED_ON_MAP =
  'age_acquisition_clicked_on_map'
export const AGE_ACQUISITION_CLICKED_ON_POD_WITH_CTA =
  'age_acquisition_clicked_on_pod_with_CTA'
export const AGE_ACQUISITION_SEARCH_FORM_NEW_DESTINATION_LIST =
  'age_acquisition_search_form_new_destination_list'
export const AGE_ACQUISITION_FREE_START_AND_END_DATE_SELECTION =
  'age_acquisition_free_date_selection_with_ga_tracking'
export const AGE_ACQUISITION_GOOGLE_FALLBACK_COT =
  'age_acquisition_autocomplete_google_fallback_methods_cot'
export const AGE_ACQUISITION_GOOGLE_FALLBACK_HOS =
  'age_acquisition_autocomplete_google_fallback_methods_hos'
export const AGE_ACQUISITION_GOOGLE_FALLBACK_NOV =
  'age_acquisition_autocomplete_google_fallback_methods_nov'
export const AGE_2784_REGION_VS_PLACES =
  'search_explore_search_age-2784_places_v_region'
export const OPTIMIZELY_FLAGS = Object.values(OPTIMIZELY_FLAGS_ENUM)
export const OPTIMIZELY_EVENTS = {
  DAY_DURATION_SELECTION_1: 'age_acquisition_1_day_duration_selection',
  DAY_DURATION_SELECTION_11: 'age_acquisition_11_day_duration_selection',
  DAY_DURATION_SELECTION_12: 'age_acquisition_12_day_duration_selection',
  DAY_DURATION_SELECTION_13: 'age_acquisition_13_day_duration_selection',
  DAY_DURATION_SELECTION_14: 'age_acquisition_14_day_duration_selection',
  DAY_DURATION_SELECTION_15: 'age_acquisition_15_day_duration_selection',
  DAY_DURATION_SELECTION_16: 'age_acquisition_16_day_duration_selection',
  DAY_DURATION_SELECTION_17: 'age_acquisition_17_day_duration_selection',
  DAY_DURATION_SELECTION_18: 'age_acquisition_18_day_duration_selection',
  DAY_DURATION_SELECTION_19: 'age_acquisition_19_day_duration_selection',
  DAY_DURATION_SELECTION_20: 'age_acquisition_20_day_duration_selection',
  DAY_DURATION_SELECTION_21: 'age_acquisition_21_day_duration_selection',
  DAY_DURATION_SELECTION_22: 'age_acquisition_22_day_duration_selection',
  DAY_DURATION_SELECTION_23: 'age_acquisition_23_day_duration_selection',
  DAY_DURATION_SELECTION_24: 'age_acquisition_24_day_duration_selection',
  DAY_DURATION_SELECTION_25: 'age_acquisition_25_day_duration_selection',
  DAY_DURATION_SELECTION_26: 'age_acquisition_26_day_duration_selection',
  DAY_DURATION_SELECTION_27: 'age_acquisition_27_day_duration_selection',
  DAY_DURATION_SELECTION_28: 'age_acquisition_28_day_duration_selection',
  NEARBY_PROPERTIES_GEOLOCATION_ACCESS_DENIED:
    'search_form___near_by_properties___geolocation_access_denied',
  NEARBY_PROPERTIES_GEOLOCATION_ERROR:
    'search_form___near_by_properties___geolocation_error',
  NEARBY_PROPERTIES_SEARCH_FORM_SUBMITTED:
    'search_form___near_by_properties___search_submitted',
  NEARBY_PROPERTIES_SEEN: 'search_form___near_by_properties___seen',
  INTERNAL_LOCATION_SUGGESTION_SHOWN:
    'age_search_internal_location_suggestion_shown',
  INTERNAL_LOCATION_SUGGESTION_NO_RESULTS:
    'age_search_internal_location_suggestion_no_results',
  INTERNAL_LOCATION_SUGGESTION_SELECTED:
    'age_search_internal_location_suggestion_selected',
}
export const WISHLIST_ENTRY_POINTS = 'guest_engagement_wishlist_v2'
export const GUEST_ENGAGEMENT_TRUSTPILOT_USPS_BANNER =
  'guest_engagement_trustpilot_usps_banner'
export const GUEST_ENGAGEMENT_TRUSTPILOT_MICRO_COMBO =
  'guest_engagement___trustpilot_banner_variants'
export const GUEST_ENGAGEMENT_HERO_TITLE = 'guest_engagement_hero_title'
export const GUEST_ACQUISITION_HERO_IMAGE = 'guest_acquisition_hero_image'
export const GTM_GOOGLE_GATEWAY_PHASE_2 = 'gtm_google_gateway_phase_2'
export const OPTIMIZELY_VARIANT_KEYS = {
  NEW_DESTINATION_LIST_LAYOUT: 'new_destination_list_layout',
  PODS_WITHOUT_BG: 'pods_without_background',
  WITHOUT_IMAGE: 'without_image',
  FREE_DATE_SELECTION: 'free_date_selection',
  CLICKED_ON_DESTINATION_PAGE_MAP: 'clicked_on_destination_page_map',
  CLICKED_ON_THEME_PAGE_MAP: 'clicked_on_theme_page_map',
  WITH_LINK: 'with_link',
  GOOGLE_FALLBACK_AUTOCOMPLETE: 'autocomplete_fallback',
  GOOGLE_FALLBACK_TEXTSEARCH: 'textsearch_fallback',
  WISHLIST_ENTRY_POINTS_VISIBLE: 'wishlist_entry_points_visible',
  TRUSTPILOT_USPS_VISIBLE: 'trustpilot_usps_visible',
  TRUSTPILOT_USPS_VISIBLE_VARIANT_A: 'trustpilot_usps_visible_variant_a',
  TRUSTPILOT_USPS_VISIBLE_VARIANT_B: 'trustpilot_usps_visible_variant_b',
  HERO_TITLE_HIDDEN: 'hero_title_hidden',
  HERO_TITLE_VISIBLE: 'hero_title_visible',
  HERO_TITLE_VISIBLE_VARIANT_A: 'hero_title_variant_a',
  HERO_TITLE_VISIBLE_VARIANT_B: 'hero_title_variant_b',
  HERO_IMAGE_VISIBLE_VARIANT: 'hero_image_variant',
  HERO_IMAGE_VISIBLE_CONTROL: 'hero_image_control',
  TRUSTPILOT_MICRO_STAR_VARIANT: 'micro_star',
  TRUSTPILOT_MICRO_COMBO_VARIANT: 'micro_combo',
}

export const DEFAULT_MAX_STAY_DURATION = 365
export const UK_MAX_STAY_DURATION = 28
export const GD_482_RADIUS_KM = 100
export const DRIVE_TIME_EXTENDED_RADIUS_KM = 300

export const CORRELATION_ID_COOKIE_NAME = 'awaze_correlation_id'

export const DATE_FORMAT = 'dd-MM-yy'

export const AGE_ACQUISITION_PODS_WITHOUT_BG =
  'age_acquisition_pods_without_background'

export const HOUR_TO_ALLOW_MAU_GENERATION_FROM = 5

export const COUNTRY_CODE_TO_TIMEZONE = {
  EU: 'Europe/Brussels',
  AT: 'Europe/Vienna',
  BE: 'Europe/Brussels',
  CH: 'Europe/Zurich',
  GB: 'Europe/London',
  DE: 'Europe/Berlin',
  FR: 'Europe/Paris',
  NL: 'Europe/Amsterdam',
  ES: 'Europe/Madrid',
  IT: 'Europe/Rome',
  NO: 'Europe/Oslo',
  SE: 'Europe/Stockholm',
  DK: 'Europe/Copenhagen',
  PL: 'Europe/Warsaw',
  HR: 'Europe/Zagreb',
}

export const OPTIMIZELY_COOKIE_VALUE_PREFIX = 'lpmfe-'
